import { CSSProperties } from "react";
import Colors from "modules/Colors";

const Divider = () => {
    return (
        <div 
            className="dividerElement" 
            style={sty.dividerElement} 
        />
    )
}

const sty: Record<string, CSSProperties> = {
    dividerElement: {
        width: '100%',
        height: 1,
        backgroundColor: Colors.greyLighter,
    }
}

export default Divider;